var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 41,
    fill: "none",
    viewBox: "0 0 56 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003F7F",
    d: "m4 2.605 7.366 11.679h33.268L52 2.605H4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0069D1",
    d: "m12.187 15.827.365.568 5.276 8.321h19.86l5.285-8.321.356-.568H12.187Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0298A6",
    d: "M20.052 29.354v9.25h14.974v-9.25a.602.602 0 0 1 .093-.333l1.732-2.762H18.217l1.732 2.762a.61.61 0 0 1 .103.333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.c745344fab7f594e2cc57094ddb649f6.svg";
export { ForwardRef as ReactComponent };